import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaBroom} from "react-icons/fa";

function CommercialCleaningServices(){

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "We were getting cleanliness complaints almost every week. After Helperji's commercial cleaning team started the situation improved gradually Now the office stays clean most of the day",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Helper Ji cleaning staff doesn’t rush the work. Floors, desks, and washrooms are cleaned properly, which we didn’t get from earlier vendors.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "The HelperJi team comes on time and finishes cleaning without disturbing employees. That regularity is the main reason we continued.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

const services = [
    {
      name: "Commercial Cleaning Services Noida",
      link: "/commercial-cleaning-services-noida",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Gurugram",
      link: "/commercial-cleaning-services-gurugram",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Ghaziabad",
      link: "/commercial-cleaning-services-ghaziabad",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Delhi",
      link: "/commercial-cleaning-services-delhi",
      icon: <FaBroom />
    }
  ];



    return(
        <Fragment>
          <Helmet>
            <title>Commercial Cleaning Services | Office Cleaning Services in Noida</title>
            {/* ===== BASIC SEO ===== */}
        <title>
          Commercial Office Cleaning Services | Professional Commercial Cleaning Company
        </title>

        <meta
          name="description"
          content="Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
        />

        <meta
          name="keywords"
          content="Commercial Office Cleaning Services, Corporate Cleaning Services, Professional Commercial Cleaning Services, Professional Commercial Cleaning Company, Professional Cleaning Services, Commercial Cleaning Company, Office Cleaning Services, Corporate Office Cleaning"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href="https://www.helperji.in/commercial-cleaning-services"
        />

        {/* ===== OPEN GRAPH (FACEBOOK / WHATSAPP) ===== */}
        <meta
          property="og:title"
          content="Commercial Office Cleaning Services | Professional Commercial Cleaning Company"
        />
        <meta
          property="og:description"
          content="Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/officeclean.jpg"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.helperji.in/commercial-cleaning-services"
        />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Commercial Office Cleaning Services | Professional Commercial Cleaning Company"
        />
        <meta
          name="twitter:description"
          content="Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/officeclean.jpg"
        />

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/commercial-cleaning-services",
            "name": "Commercial Office Cleaning Services | Professional Commercial Cleaning Company",
            "description": "Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
          }
          `}
        </script>

        {/* ===== PRODUCT SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Commercial Cleaning Services",
            "image": "https://www.helperji.in/assets/img/officeclean.jpg",
            "description": "Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services.",
            "brand": {
              "@type": "Brand",
              "name": "Helper Ji"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "ratingCount": "698"
            }
          }
          `}
        </script>

        {/* ===== BREADCRUMB SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.helperji.in"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Commercial Cleaning Services",
                "item": "https://www.helperji.in/commercial-cleaning-services"
              }
            ]
          }
          `}
        </script>
         <script type="text/javascript">
          {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
        </script>
          </Helmet>
            <Floatingcall />
            <section id="about" class="about">
      <div class="container" data-aos="fade-up">

        <div class="section-header">
          <h2>Commercial Cleaning Services</h2>
          <p>Are you looking for <b>best Commercial Cleaning service near me</b> then contact Helper Ji today. </p>
        </div>

        <div class="row gy-4">
          <div class="col-lg-6">
            <img src="/assets/img/officeclean.jpg" class="img-fluid rounded-4 mb-4" alt="" />
          </div>
          
          <div class="col-lg-6">
            <div class="content ps-0 ps-lg-5">
              <p className="text-justify">
              HelperJi provides the best commercial cleaning services for you. Taking pride in providing <a href="https://www.helperji.in/commercial-cleaning-services"><strong> office cleaning services in Noida </strong></a>, Helper Ji is one of the best office cleaning companies. Our cleaning concept uses innovative deep cleaning methods to represent a professional approach to office cleaning. 
              </p>
              <ul>
                <li><i class="bi bi-check-circle-fill"></i>We clean the ceiling fans, air conditioner vents, and lights, as well as vacuum the coves. </li>
                <li><i class="bi bi-check-circle-fill"></i>The computers and pin boards are cleaned, the electronics are dusted, and the pin boards are vacuumed by our team.</li>
                <li><i class="bi bi-check-circle-fill"></i>The computers and pin boards are cleaned, the electronics are dusted, and the pin boards are vacuumed by our team.</li>
                <li><i class="bi bi-check-circle-fill"></i>Pinboards need to be vacuumed, computers need to be cleaned, and dusting needs to be done while office cleaning.</li>
                <li><i class="bi bi-check-circle-fill"></i>The team cleans workstations, vacuums pinboards, and dusts electronic devices as needed.</li>
              </ul>
               </div>
          </div>
        </div>
      </div>
    </section>
     
    <section id="services" class="services sections-bg">
          <div class="container" data-aos="fade-up">
    
            <div class="row gy-4">
              
              <div class="col-lg-6">
                <div class="content ps-0 ps-lg-5">
                  <h3>We follow safety standards when deep cleaning your office</h3>
                  <p className="text-justify">
                    At Helper Ji Services, we offer a variety of deep cleaning services for workplaces. It is of utmost importance to us as an office cleaning company to ensure the safety and health of employees. 
                  </p>
                  <p className="text-justify">
                    In addition to delivering high-quality <strong><a href="https://www.helperji.in/commercial-cleaning-services">commercial cleaning services</a></strong> on-site, we are recognized as a trusted cleaning company. As a result of complying with government and industry standards, we provide services of the highest quality.
                  </p>
                  <p className="text-justify">Providing you with commercial cleaning services requires extensive training on the part of Helper Ji's cleaners. Our company provides cleaning services for businesses through a team of professionals who are certified in this field.</p>
                  <p className="text-justify">When providing corporate cleaning services, our professionals use safe and effective cleaning equipment and tools.</p>
                </div>
              </div>
              <div class="col-lg-6">
                <img src="/assets/img/officecleaning.jpg" class="img-fluid rounded-4 mb-4" alt="" />
                
              </div>
            </div>
    
          </div>
        </section>

           <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
           </section>

     <section id="services" class="services sections-bg">
        <div className="container">
          <h3>
            FAQs – COMMERCIAL CLEANING SERVICES
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  What makes Helper Ji one of the best office cleaning services in Delhi NCR?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our focus on hygiene, safety, and detail makes us one of the Best Office Cleaning Services in Delhi NCR for corporate and business spaces.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Do you offer deep office cleaning services in Delhi NCR?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, we specialise in Deep Office Cleaning Services in Delhi NCR, covering floors, workstations, furniture, and shared areas.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Are your commercial cleaning services in Delhi NCR suitable for large offices?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Absolutely. Our Commercial Cleaning Services in Delhi NCR are suitable for startups, mid-sized offices, and large corporate workplaces.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Do you use safe products for professional commercial cleaning services?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, all professional commercial cleaning services are performed using safe and office-friendly cleaning products.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Can I schedule professional cleaning services outside office hours in Delhi NCR?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, we offer flexible scheduling for professional cleaning services to avoid work disruption.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <LandingPageClient /> 

           <section className="py-5 sections-bg">
                                <div className="container">
                                  <div className="row mb-4">
                                    <div className="col text-center">
                                      <h2 className="fw-bold">Our Locations</h2>
                                      <p className="text-muted">
                                        Explore Our locations of Housekeeping Manpower
                                        Services
                                      </p>
                                    </div>
                                  </div>
                          
                                  <div className="row g-4">
                                    {services.map((service, index) => (
                                      <div className="col-md-3 col-sm-6" key={index}>
                                        <Link
                                          to={service.link}
                                          className="text-decoration-none text-dark"
                                        >
                                          <div className="card h-100 shadow-sm border-0 service-card">
                                            <div className="card-body d-flex align-items-center">
                                              <div className="service-icon me-3">
                                                {service.icon}
                                              </div>
                                              <h6 className="mb-0 fw-semibold">
                                                {service.name}
                                              </h6>
                                            </div>
                                          </div>
                                        </Link>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </section>

        </Fragment>
    )
}

export default CommercialCleaningServices;